module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 XL Just Black.4d1c0a68.png";